import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { ParentContext } from "../ParentContext";
import { createManifestIcons } from "global/components/imaging/createManifestIcons";

export const useFileImage = ({ _profiles, forMulti }) => {

  const [imageDropedFile, setImageDroppedFile] = useState(null);
  const [imageDroppedFiles, setImageDroppedFiles] = useState([]);

  const [imageDroppedPreview, setImageDroppedPreview] = useState(null);
  const [imageDroppedPreviews, setImageDroppedPreviews] = useState([]);
  const [manfestDroppedPreviews, setManifestDroppedPreviews] = useState([])

  const handleClear = useCallback((items) => {
    setImageDroppedFile()
    setImageDroppedFiles([])
    setImageDroppedPreview()
    setImageDroppedPreviews([])
    setManifestDroppedPreviews([])
  }, []);

  const handleCreate_fileList = useCallback((items) => {
    const _items = {}
    _.forEach(items, (item, itemKey) => {
      _items[item._itemKey] = {
        email: item.email,
        file: item._file,
        fileStatusType: 'approved',
        _itemKey: itemKey
      }
    })
    return _items
  }, []);

  const handle_onFileDrop = useCallback((acceptedFiles) => {
    if (!acceptedFiles) { return; }
    if (forMulti) {
      setImageDroppedFiles((prevFiles) => {
        const newFiles = acceptedFiles
          .map((fileImage) => ({ name: fileImage.name, fileImage }))
          .filter((newFile) => !prevFiles.some((prevFile) => prevFile.name === newFile.name));
        return [...prevFiles, ...newFiles];
      });
    } else {
      const fileImage = acceptedFiles[0];
      if (fileImage) {
        setImageDroppedFile({ name: fileImage.name, fileImage });
      } else {
        setImageDroppedFile();
      }
    }
    // Get the first accepted file
    const fileImage = acceptedFiles[0];
    if (fileImage) {
      setImageDroppedFile({ name: fileImage.name, fileImage });
    }
  }, []);

  useEffect(() => {
    if (forMulti) {
      if (imageDroppedFiles) {
        let previews = []
        _.forEach(imageDroppedFiles, (image_file) => {
          const preview = URL.createObjectURL(image_file.fileImage);
          previews.push(preview)
        })
        setImageDroppedPreviews(previews);
      }
    } else {
      if (imageDropedFile) {
        const preview = URL.createObjectURL(imageDropedFile.fileImage);
        switch (storageType) {
          case gEnums.storageTypes.manifest:
            const manifestName = 'manifest'
            createManifestIcons(imageDropedFile.fileImage).then(res => {
              const _manifestFiles = []
              res.forEach((r, index) => {
                const _fileImage = new File([r], manifestName + '_' + index, { type: r.type })
                _manifestFiles.push({ name: _fileImage.name, fileImage: _fileImage })
              })
              setManifestDroppedPreviews(_manifestFiles)
            })
          default:
          // nothing
        }
        setImageDroppedPreview(preview);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imageDropedFile, imageDroppedFiles]);

  const { allDroppedFiles, imageFiles, attendeeFiles } = useMemo(() => {
    if (!_.isEmpty(imageDroppedFiles) && !_.isEmpty(imageDroppedPreviews)) {
      const result = imageDroppedFiles.map((item, i) => ({
        ...item,
        src: imageDroppedPreviews[i]
      }));

      // result => [fileImage, name, src]

      const pendingFiles = {}
      const _attendeeProfiles = {}
      const _attendeeFiles = {}

      _.forEach(result, (res) => {
        const aaa = handleGet_nameFromFile(res, _profiles)
        if (aaa) {
          res._dataItem = {
            email: aaa?.email,
            displayName: aaa?.displayName,
            _itemKey: aaa?._itemKey
          }
        }
      })


      _.forEach(_profiles, (ap, apKey) => {
        const zzz = handleGet_fileFromName(result, apKey, ap, pendingFiles)
        if (zzz) {
          _attendeeProfiles[apKey] = {
            ...ap,
            _file: zzz[0]
          }
          _attendeeFiles[ap._itemKey] = {
            email: ap.email,
            file: zzz[0],
            fileStatusType: 'approved',
            _itemKey: ap._itemKey
          }
        } else {

        }
      })
      console.log('result', result)
      return { allDroppedFiles: result, imageFiles: _attendeeProfiles, attendeeFiles: _attendeeFiles }
    }
    return {}
  }, [imageDroppedFiles, imageDroppedPreviews])

  return {
    handle_onFileDrop,
    handleCreate_fileList,
    handleClear,
    fileInfos: {
      allDroppedFiles,
      imageDropedFile,
      imageDroppedFiles,
      imageDroppedPreview,
      imageDroppedPreviews,
      manfestDroppedPreviews,
      imageFiles,
      attendeeFiles,
    }
  };

};

const handleGet_fileFromName = (selectedFolderFiles, dataKey, dataItem, pendingFiles) => {

  const { lastName, firstName, name, fullName, email } = dataItem

  pendingFiles[dataKey] = { _itemKey: dataKey, firstName, lastName, name: lastName ? lastName + ', ' + firstName : name, fullName, email }

  const _ln = lastName && lastName.toLowerCase().replace("'", '')
  const _fn = firstName && firstName.toLowerCase()
  const _nm = name && name.toLowerCase()
  const _nmm = name && name.toLowerCase().replace(/\W/g, '')

  const _file = _.filter(selectedFolderFiles, function (folderFile) {
    const { name: name_file } = folderFile
    let n = name_file.replace(/\W/g, '')
    n = n.replace('jpg', '')
    n = n.replace('png', '')
    if (_ln && _fn) {
      return (n.toLowerCase().indexOf(_fn) >= 0 && n.toLowerCase().indexOf(_ln) >= 0)
    } else {
      return (n.toLowerCase().indexOf(_nm) >= 0) || (n.toLowerCase().indexOf(_nmm) >= 0)
    }
  })

  switch (_file.length) {
    case 0:
      return;
    case 1:
      return _file
    default:
      const _file2 = _.filter(_file, function (f) {
        if (fullName) {
          const fullNameS = fullName.split(' ')
          let exists = true;
          fullNameS.forEach(fns => {
            if (f.name.indexOf(fns) < 0) {
              exists = false
            }
          })
          return exists
        }
      })

      switch (_file2.length) {
        case 0:
          return;
        case 1:
          return _file2
        default:
          return;
      }
  }
};

const handleGet_nameFromFile = (res, attendeeProfiles) => {

  const { name: name_file, fileImage, src } = res

  const _profile = _.find(attendeeProfiles, function (attendeeProfile) {
    const { lastName, firstName, name, fullName, email } = attendeeProfile
    const _ln = lastName && lastName.toLowerCase().replace("'", '')
    const _fn = firstName && firstName.toLowerCase()
    const _nm = name && name.toLowerCase()
    const _nmm = name && name.toLowerCase().replace(/\W/g, '')
    let n = name_file.replace(/\W/g, '')
    n = n.replace('jpg', '')
    n = n.replace('png', '')
    if (_ln && _fn) {
      return (n.toLowerCase().indexOf(_fn) >= 0 && n.toLowerCase().indexOf(_ln) >= 0)
    } else {
      return (n.toLowerCase().indexOf(_nm) >= 0) || (n.toLowerCase().indexOf(_nmm) >= 0)
    }
  })

  return _profile
};